import {
  Button,
  Col,
  Divider,
  Drawer,
  Layout,
  Menu,
  Row,
  Select,
  Input,
  Carousel,
  Checkbox
} from 'ant-design-vue';

export function setupAntd(app) {
  app.component(Button.name, Button);
  app.component(Col.name, Col);
  app.component(Divider.name, Divider);
  app.component(Drawer.name, Drawer);
  app.component(Layout.Header.name, Layout.Header);
  app.component(Menu.name, Menu);
  app.component(Row.name, Row);
  app.component(Select.name, Select);
  app.component(Select.Option.name, Select.Option);
  app.component(Input.name, Input);
  app.component(Input.TextArea.name, Input.TextArea);
  app.component(Carousel.name, Carousel);
  app.component(Checkbox.name, Checkbox);
}
